import { SqButton } from "@/components/squircle-ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { RiMore2Fill } from "@remixicon/react";
import { IconInfoCircle } from "@tabler/icons-react";
import { useState } from "react";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
};

const DangerZoneDropdown = (props: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <SqButton size={"md"} variant="outline" className="w-[32px]">
          <RiMore2Fill size={14} className="text-brand-primary-400 shrink-0" />
        </SqButton>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="top"
        className="w-auto p-1 bg-white shadow-none rounded-[10px] border-0 squircle squircle-radius-[12px] squircle-smooth-[1] squircle-outline-[1px] squircle-outline-color-border-gray"
      >
        <div
          onClick={() => {
            props.onChange(!props.value);
          }}
          className={cn(
            "flex gap-[6px] h-[28px] pl-2 pr-[12px] py-1 rounded-sm items-center self-stretch cursor-pointer text-brand-primary-800 hover:text-brand-primary-800 text-[12px] hover:bg-hover-gray",
          )}
        >
          <Switch
            checked={props.value}
            className="h-4 w-7 data-[state=unchecked]:bg-border-gray data-[state=checked]:bg-brand-orange"
            thumbClassName="h-3 w-3 data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0.1"
          />
          <div>Danger Zone</div>
          <TooltipProvider>
            <Tooltip delayDuration={200}>
              <TooltipTrigger>
                <IconInfoCircle size={14} className="text-brand-primary-400 shrink-0" />
              </TooltipTrigger>
              <TooltipContent
                side="right"
                sideOffset={24}
                alignOffset={-8}
                align="end"
                className="p-[12px] squircle-mask rounded-[8px]"
              >
                <div className="flex flex-col gap-[12px] items-start">
                  <div className="relative">
                    <svg
                      width="148"
                      height="103"
                      viewBox="0 0 148 103"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_41235_55922)">
                        <rect
                          y="103"
                          width="103"
                          height="148"
                          transform="rotate(-90 0 103)"
                          fill="#333334"
                        />
                        <rect
                          y="103"
                          width="12"
                          height="148"
                          transform="rotate(-90 0 103)"
                          fill="#D9D9D9"
                          fill-opacity="0.2"
                        />
                        <rect
                          y="12"
                          width="12"
                          height="148"
                          transform="rotate(-90 0 12)"
                          fill="#D9D9D9"
                          fill-opacity="0.2"
                        />
                        <rect width="12" height="103" fill="#D9D9D9" fill-opacity="0.2" />
                        <rect
                          x="136"
                          width="12"
                          height="103"
                          fill="#D9D9D9"
                          fill-opacity="0.2"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_41235_55922">
                          <rect
                            y="103"
                            width="103"
                            height="148"
                            rx="4"
                            transform="rotate(-90 0 103)"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 text-[11px] font-normal opacity-80">
                      Safe area
                    </div>
                  </div>
                  <span>
                    Keeps content outside a 10%{" "}
                    <span className="font-medium">‘danger zone’</span> to <br /> prevent
                    Meta UI from cutting it off.
                  </span>
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DangerZoneDropdown;
